/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { ReactComponent as GlobalIcon } from '../../../src/assets/icons/globalIcon.svg';
import { ReactComponent as PrivateIcon } from '../../../src/assets/icons/sharedIcon.svg';
import { ReactComponent as SharedIcon } from '../../../src/assets/icons/privateIcon.svg';
import { ReactComponent as CreateIcon } from '../../../src/assets/icons/createIcon.svg';
import { InteractiveTooltip } from '../utils/interactivetooltip';
import { setInteractiveType } from '../../redux/handleBrowserBack';
import { useDispatch, useSelector } from 'react-redux';
import { Dropdown } from 'react-bootstrap';
import { ParentDataInterface, setInteractiveState } from '../../redux/parentDataSlice';
interface IconData {
  className: string;
  IconComponent: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  pathname: string;
  tooltipInfo: string;
  type: string;
}

const icons: IconData[] = [
  {
    className: 'createIcon',
    IconComponent: CreateIcon,
    pathname: '/library',
    tooltipInfo: 'Create New',
    type: 'library',
  },
  {
    className: 'globalIcon',
    IconComponent: GlobalIcon,
    pathname: '/global',
    tooltipInfo: 'Global Interactive',
    type: 'global',
  },
  {
    className: 'privateIcon',
    IconComponent: PrivateIcon,
    pathname: '/interactives',
    tooltipInfo: 'Private Interactive',
    type: 'private',
  },
  {
    className: 'sharedIcon',
    IconComponent: SharedIcon,
    pathname: '/shared',
    tooltipInfo: 'Shared Interactive ',
    type: 'shared',
  },
];

const IconsSidebar = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const navigateToPath = (pathname: string, type: string) => {
    dispatch(setInteractiveState(type));
    history.push(pathname);
    dispatch(setInteractiveType(pathname));
  };
  const customConfiguration = useSelector((state: ParentDataInterface) => state.parentData);
  const interactiveState = useSelector(
    (state: ParentDataInterface) => state.parentData.interactiveState,
  );
  const configCheck = customConfiguration?.customConfiguration?.config;
  const renderIcon = ({ className, IconComponent, pathname, tooltipInfo, type }: IconData) => {
    const isActive = location.pathname.startsWith(pathname);
    const isLibrary = pathname.startsWith('/library');
    let hideIcon = false;
    const canCreateOriginal =
      configCheck?.myinteractivecreate || configCheck?.globalinteractivecreate;

    const canCreateCollaborative = configCheck?.collaborativeinteractivecreate;

    const createCount = Number(canCreateOriginal ? 1 : 0) + Number(canCreateCollaborative ? 1 : 0);
    if (isLibrary && createCount === 1) {
      type = canCreateCollaborative ? 'collaborative' : '/library';
    } else if (isLibrary && createCount == 0) {
      hideIcon = true;
    }
    if (isLibrary && createCount > 1) {
      return (
        <Dropdown drop='end' className='createInteractive'>
          <Dropdown.Toggle
            as='div'
            role='button'
            tabIndex={0}
            className={`${className}Div ${isActive ? 'active' : ''}`}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
              }
            }}
          >
            <InteractiveTooltip info={tooltipInfo} direction='right' key={className} isAlignright>
              <div className={className}>
                <IconComponent width={20} height={20} />
              </div>
            </InteractiveTooltip>
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item
              className={`optionForCreateInteractive ${
                interactiveState === '/library' ? 'active' : ''
              }`}
              onClick={() => navigateToPath(pathname, '/library')}
            >
              Create Original Interactive
            </Dropdown.Item>
            <Dropdown.Item
              className={`optionForCreateInteractive ${
                interactiveState === 'collaborative' ? 'active' : ''
              }`}
              onClick={() => navigateToPath(pathname, 'collaborative')}
            >
              Create Open Interactive
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      );
    }
    return (
      <InteractiveTooltip info={tooltipInfo} direction='right' key={className}>
        <div
          className={`${className}Div ${isActive ? 'active' : ''} ${hideIcon ? 'd-none' : ''}`}
          role='button'
          tabIndex={0}
          onClick={() => {
            navigateToPath(pathname, type);
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              navigateToPath(pathname, type);
            }
          }}
        >
          <div className={className}>
            <IconComponent width={20} height={20} />
          </div>
        </div>
      </InteractiveTooltip>
    );
  };
  return <div className='left-content'>{icons.map((icon) => renderIcon(icon))}</div>;
};

export default IconsSidebar;
